export default {
  ApiErrors: {
    generic: 'Wystąpił błąd. Proszę odświeżyć stronę i skontaktować się z nami, jeśli problem będzie się powtarzał.',
    'Email already exists': 'E-mail jest już zajęty',
    'This field is required.': 'To pole jest wymagane',
    'First_name must be filled': 'Imię jest wymagane',
    'Password length must be over 8 characters': 'Hasło musi mieć co najmniej 8 znaków',
    'Unable to login with the provided credentials': 'Nie można zalogować się przy użyciu podanych danych',
    'godson is already a customer': 'Ten e-mail jest już używany przez klienta',
    'godson is in referral process': 'Ten e-mail jest już w procesie polecenia.',
    'Enter a valid email address': 'To nie jest poprawny adres e-mail',
    'Email already in db': 'E-mail jest już zajęty',
    'Not an email': 'Niepoprawny e-mail',
    'Reward is soldout': 'Ta nagroda jest wyprzedana',
    'Reward can only be claimed once': 'Już odebrałeś tę nagrodę',
    'Reward is no longer valid': 'Ta nagroda nie jest już ważna',
    'Not enough points': 'Nie masz wystarczającej liczby punktów',
    'Account already in use': 'To konto jest już używane przez innego użytkownika',
    'This instagram account does not exist on Instagram': 'To konto na Instagramie nie istnieje',
    'social error': "Proszę wprowadzić swoje konto {'@'}mojekonto",
    'required field': 'Proszę wypełnić to pole',
    'value error': 'Wprowadzona wartość jest niepoprawna',
    'You already applied a discount code': 'Już zastosowałeś kod rabatowy'
  },
  Error: {
    generic: 'Wystąpił błąd, proszę odświeżyć stronę.',
    link: 'Odśwież stronę',
    title: 'Loyoly - Ups! Błąd',
    blacklistMessage1: 'Nie kwalifikujesz się do programu lojalnościowego.',
    blacklistMessage2: 'Skontaktuj się z zespołem wsparcia, jeśli uważasz, że to błąd.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'Proszę podać prawidłowy adres e-mail',
      emailEmpty: 'Proszę podać swój adres e-mail'
    }
  },
  InApp: {
    message: 'Aby uzyskać optymalne doświadczenie, przejdź do swojej domyślnej przeglądarki'
  },
  Phone: {
    countrySelector: {
      placeholder: 'Kod kraju',
      error: 'Wybierz kraj',
      searchPlaceholder: 'Wybierz kraj'
    },
    phoneInput: {
      placeholder: 'Numer telefonu',
      example: 'Przykład:'
    },
    error: {
      invalid: 'Proszę podać poprawny numer telefonu'
    }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'Połącz z moim kontem na Instagramie',
      subtitle: 'Jak to działa',
      description:
        'Proszę wprowadzić swoje konto na Instagramie i upewnić się, że jest publiczne przed realizacją misji.',
      form: {
        username: 'Konto na Instagramie',
        usernameExample: "{'@'}johndoe"
      },
      errors: {
        usernameEmpty: 'Proszę podać nazwę konta',
        usernameNotFound: 'Proszę podać poprawną nazwę konta'
      },
      button: 'Potwierdź'
    },
    ModalSearching: {
      title: 'Szukamy Twojego konta'
    },
    ModalLinked: {
      title: 'Połącz z moim kontem na Instagramie',
      private: {
        subtitle: 'Nie można połączyć z Twoim kontem',
        description: {
          title: 'Twoje konto na Instagramie jest prywatne',
          text: 'Niestety, Twoje konto na Instagramie jest prywatne. Przełącz na publiczne, aby uzyskać dostęp do wszystkich misji.'
        }
      },
      public: {
        subtitle: 'Połączenie z kontem zakończone sukcesem',
        description: {
          title: 'Gratulacje',
          text: 'Możesz teraz realizować misje.'
        }
      },
      buttons: {
        edit: 'Edytuj moje konto',
        retry: 'Spróbuj ponownie',
        goback: 'Wróć do strony',
        gotoChallenge: 'Przejdź do misji'
      }
    },
    ModalNotFound: {
      title: 'Połącz z moim kontem na Instagramie',
      subtitle: 'Nie można połączyć z Twoim kontem',
      description: {
        title: 'Nie znaleziono konta',
        text: 'Proszę zmienić konto lub skontaktować się z pomocą techniczną.'
      },
      buttons: {
        change: 'Zmień konto',
        retry: 'Spróbuj ponownie'
      }
    }
  },
  Modal: {
    Notifications: {
      title: 'Powiadomienia e-mail',
      information: {
        title: 'Informacje',
        text: 'Jeśli nie chcesz otrzymywać przypomnień o misjach, aktualności lub przypomnień o nagrodach, możesz zrezygnować, odznaczając poniższe pola wyboru:'
      },
      communication: {
        optinTransactional: 'Promocyjne: informacje o programie, poziomach VIP, nagrodach.',
        optinMarketing: 'Informacyjny: Informacje o zakupach i sponsoringu.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'Konto publiczne',
        private: 'Konto prywatne',
        followers:
          '<span class="weglot-ignore">{n}</span> obserwujący | <span class="weglot-ignore">{n}</span> obserwujących'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> punkt | <span class="weglot-ignore">{n}</span> punkty',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> punkt | <span class="weglot-ignore">{value}</span> punkty',
  SectionHeader: {
    poweredBy: 'Napędzane przez'
  },
  SectionChallenges: {
    empty: 'W Twoim programie lojalnościowym nie ma dostępnych misji',
    showAll: 'Pokaż wszystko',
    ModalMissionDetail: {
      description: 'Opis',
      pointsToEarn: 'Punkty do zdobycia',
      howto: 'Jak to działa?',
      uploadMedia: 'Załaduj swoje media',
      reviewApplication: 'Zostaw opinię',
      linkApplication: 'Pobierz aplikację',
      newsletterPartners:
        'Klikając „Zatwierdź misję”, wyrażasz zgodę na otrzymywanie ofert handlowych od firmy drogą elektroniczną.',
      phonePartners: 'Zgadzam się, aby mój numer telefonu był wykorzystywany do otrzymywania ofert SMS.',
      clue: 'Wskazówka',
      linkPage: 'Zobacz stronę',
      instaMention: 'Oznacz',
      tiktokMention: 'Oznacz',
      instaHashtags: 'Użyj hashtagów',
      tiktokHashtags: 'Użyj hashtagów',
      linkToShare: 'Link do umieszczenia w swojej relacji',
      linkShare: 'Link do udostępnienia',
      vouchertoShare: 'Kod promocyjny do udostępnienia',
      goToAccount: 'Przejdź do konta',
      goToInsta: 'Przejdź do konta',
      goToInstaPost: 'Przejdź do posta na Instagramie',
      goToInstaReel: 'Przejdź do reel na Instagramie',
      goToInstaIGTV: 'Przejdź do IGTV na Instagramie',
      goToTweeterTweet: 'Przejdź do tweeta',
      goToReview: 'Zostaw opinię',
      goToShop: 'Przejdź do sklepu',
      goToLink: 'Przejdź do strony',
      goToTypeform: 'Wypełnij formularz',
      goToWhatsapp: 'Dołącz do grupy',
      submit: 'Zatwierdź misję',
      missionPendingTitle: 'Misja w trakcie weryfikacji',
      missionPendingExplain: 'Twoje punkty wkrótce zostaną przyznane.',
      actionSurveyTextError: 'Proszę wybrać odpowiedź',
      actionEmailError: 'Twój e-mail jest nieprawidłowy',
      actionInputError: 'To pole jest nieprawidłowe',
      actionInputImageError: 'Proszę załadować swoje media',
      handlingMedia: 'Przetwarzanie mediów',
      errorMediaHandle: 'Wystąpił błąd podczas przetwarzania Twoich mediów',
      imageInvalid: 'Wystąpił błąd podczas przetwarzania Twoich mediów',
      videoSize: 'Rozmiar Twojego wideo musi być mniejszy niż 100 MB.',
      errorInstaReel: 'Adres URL Twojego reel jest nieprawidłowy',
      'This url is not a valid google url': 'Adres URL Twojej opinii Google jest nieprawidłowy',
      'This url is not a valid reel url': 'Adres URL Twojego reel jest nieprawidłowy',
      refusalReasonCondition: 'Naruszenie warunków',
      refusalReasonQuality: 'Zbyt niska jakość',
      refusalReasonContent: 'Nieodpowiednia treść',
      refusalReasonSound: 'Niesłyszalny dźwięk',
      missionInvalidTitle: 'Misja unieważniona',
      missionInvalidDescription: 'Możesz ponownie wykonać misję, dokładnie przestrzegając wymaganych zasad',
      missionInvalidReasons: 'Powód odmowy:',
      condition: 'Warunki',
      conditionExplanation: 'Miej więcej niż',
      ineligible: 'Niekwalifikowany',
      ineligibleExplanation:
        'Wygląda na to, że nie masz wymaganej liczby obserwujących. Jeśli masz więcej obserwujących, zaktualizuj dane swojego konta.',
      lastUpdate: 'Ostatnia aktualizacja',
      updateAccount: 'Zaktualizuj moje konto',
      reviewLastPurchase: 'Zostaw opinię na stronie produktu swojego ostatniego zakupu',
      whenReviewValidated: 'Po zatwierdzeniu opinii Twoja misja zostanie automatycznie zatwierdzona',
      pointsToEarnPhoto: 'Dodatkowe punkty za zdjęcie',
      pointsToEarnVideo: 'Dodatkowe punkty za wideo',
      howtoBirthdate: 'Podaj swoją datę urodzenia',
      errorInvalidDate: 'Proszę podać prawidłową datę',
      inputMedia: 'Załaduj swoje media',
      inputMediaLoaded: 'Twoje media zostały pomyślnie załadowane',
      placeholderAnswer: 'Napisz swoją odpowiedź tutaj',
      misteryAnswer: 'Jakie jest tajemnicze słowo?',
      newsletterEmail: 'Potwierdź swój adres e-mail',
      birthDate: 'Data urodzenia',
      example: 'Przykład',
      goToChallenge: 'Przejdź do misji'
    },
    ModalMissionImageRights: {
      imageRights:
        'Zaznaczając to pole, potwierdzam, że jestem autorem treści, wyraźnie zgadzam się na przeniesienie związanych z nią praw własności intelektualnej i wyrażam zgodę na wykorzystanie mojego wizerunku przez markę do celów komercyjnych zgodnie z warunkami określonymi w ',
      imageRightsLink: 'tej umowie.',
      title:
        'Umowa o przeniesienie praw własności intelektualnej do treści i zgoda na wykorzystanie moich cech osobistych.',
      content: 'Wyrażam wyraźną zgodę na publikację treści stworzonych w ramach mojego zadania (dalej „Treść”):',
      bullet1:
        'oznacza przeniesienie na rzecz marki całości autorskich praw majątkowych do Treści, na całym świecie, na cały okres obowiązywania ochrony praw autorskich, na zasadach wyłącznych i ostatecznych. Przyjmuję do wiadomości, że przeniesienie to następuje w zamian za punkty zdobyte w ramach mojego zadania, które stanowią należytą rekompensatę. Przeniesienie obejmuje prawo marki do powielania i rozpowszechniania Treści w całości lub w części, na wszelkich nośnikach i za pomocą wszelkich znanych lub nieznanych, przewidywalnych lub nieprzewidywalnych środków, jak również prawo do tłumaczenia, aranżowania, modyfikowania, adaptacji i/lub poprawiania Treści przez markę, samodzielnie lub we współpracy z osobami trzecimi. Zobowiązuję się, że Treść nie narusza praw osób trzecich ani nie stanowi naruszenia praw autorskich, i gwarantuję marce pełne zabezpieczenie w tym zakresie;',
      bullet2:
        'oznacza udzielenie marce nieodpłatnej zgody na utrwalanie, reprodukcję, rozpowszechnianie i publiczne udostępnianie moich cech osobistych związanych z Treścią, na wszystkich nośnikach i wszelkimi znanymi lub nieznanymi, przewidywalnymi lub nieprzewidywalnymi środkami przekazu, mediami, sieciami i kanałami dystrybucji, w celach eksploatacji, informacji, komunikacji, promocji i reklamy produktów marki przez okres 10 lat, z możliwością przedłużenia za obopólną zgodą.',
      end1: 'Niniejsza umowa podlega prawu francuskiemu i będzie zgodnie z nim interpretowana.',
      end2: 'Wszelkie spory dotyczące ważności, interpretacji lub wykonania umowy będą podlegać wyłącznej jurysdykcji sądów w Paryżu, z wyjątkiem przypadków przewidzianych przez przepisy proceduralne.'
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        '<span class="weglot-ignore">{points}</span> punkt do zdobycia za każde wydane <span class="weglot-ignore">{amountToPoints}</span> | <span class="weglot-ignore">{points}</span> punktów do zdobycia za każde wydane <span class="weglot-ignore">{amountToPoints}</span>',
      orderNumber: 'Zamówienie nr',
      orderDate: 'Data',
      orderAmount: 'Kwota',
      orderRewardable: 'Nagradzane',
      orderPoints: 'Zdobyte punkty',
      orderPaid: 'Zatwierdzone',
      orderStatus: 'Status',
      orderCancel: 'Zwrócone',
      orderRefund: 'Częściowo zwrócone',
      orderWaiting: 'Oczekujące'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'Zobacz warunki',
      seePrivacy: 'Zobacz prywatność'
    }
  },
  SectionProfile: {
    socialNetworks: {
      instagram: 'Połącz z Instagramem',
      tiktok: 'Połącz z TikTok'
    },
    notificationsByEmails: 'Powiadomienia e-mail',
    cgu: 'Warunki ogólne'
  },
  SectionAccountRewards: {
    empty: 'Nie ma już nagród do wymiany i nie masz żadnych nagród oczekujących na wykorzystanie',
    copied: 'Skopiowano!'
  },
  SectionRewards: {
    empty: 'W Twoim programie lojalnościowym nie ma dostępnych nagród',
    showAll: 'Pokaż wszystko',
    Card: {
      channel_store: 'W sklepie stacjonarnym',
      channel_online: 'Online',
      channel_both: 'Online i w sklepie stacjonarnym'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'Moje nagrody',
    empty: 'Nie masz jeszcze żadnych nagród.',
    emptyTip: 'Możesz realizować misje i wymieniać zdobyte punkty na nagrody',
    use: 'Użyj',
    expired: 'Wygasło'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'Data wygaśnięcia',
    expirationDelayExplain:
      'Nagroda będzie dostępna przez <span class="weglot-ignore">{expiration_delay}</span> dni po jej wymianie.',
    minimumBuy: 'Minimalna kwota zakupu',
    maxAmount: 'Ważne do',
    description: 'Opis',
    saleChannel: 'Kanał sprzedaży',
    channelStore: 'W sklepie',
    channelOnline: 'Online',
    channelBoth: 'Online i w sklepie'
  },
  SectionRewardsDetailModal: {
    exchange: 'Wymień',
    errorMessage1: 'Wydaje się, że wystąpił problem.',
    errorMessage2: 'Twoja nagroda nie została wymieniona i twoje punkty nie zostały odjęte.',
    errorMessage3: 'Proszę odświeżyć stronę.',
    errorButton: 'Odśwież stronę'
  },
  SectionRewardsClaimModal: {
    howItWorks: 'Jak to działa?',
    howItWorkCode: 'Użyj swojego kodu na naszej stronie podczas składania zamówienia',
    howItWorkCodePOS: 'Okaż swój kod bezpośrednio w sklepie przy kasie.',
    howItWorkCodeCMSPOS:
      'Użyj swojego kodu na naszej stronie internetowej podczas składania zamówienia lub okaż go bezpośrednio w sklepie przy kasie.',
    howItWorkCodeProduct: 'Dodaj produkt do koszyka, a następnie użyj kodu przy składaniu zamówienia',
    howItWorkCodeRecharge: 'Dodaj kod bezpośrednio w swoim portalu klienta',
    howItWorkExt: 'Skontaktujemy się z Tobą w celu odbioru nagrody',
    applyToBasket: 'Zastosuj do koszyka',
    apply: 'Zastosuj',
    applied: 'Zastosowane',
    link: 'Link do produktu',
    copied: 'Skopiowane!',
    customerPortal: 'Portal klienta',
    nonApplicable: 'Nieuprawniony'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'Zastosuj',
    nonApplicable: 'Nieuprawniony',
    itemTitle: '{title} / {price}',
    customerPortal: 'Portal klienta'
  },
  SectionReferral: {
    friendEmail: 'E-mail Twojego przyjaciela',
    seeReferral: 'Zobacz moje polecenia',
    errors: {
      emailSelf: 'Wprowadzony e-mail jest taki sam jak Twój e-mail'
    },
    Tabs: {
      link: 'Link',
      email: 'E-mail',
      sms: 'SMS',
      copy: 'Kopiuj link',
      smsSend: 'Wyślij wiadomość',
      reward1: '{amount} punktów',
      reward2: '{amount}% zniżki',
      reward3: 'Kupon na {amount}',
      smsTemplate:
        'Cześć! Odkryłem {brand_name}, który może Ci się spodobać.\n\n Korzystając z mojego linku polecającego {referral_link}, skorzystasz z {reward_friend}.\n\nSkorzystaj z tego, to naprawdę interesująca oferta!\nDo zobaczenia!'
    },
    Modal: {
      emptyState: 'Nie dokonałeś jeszcze żadnych poleceń',
      title: 'Moje polecenia',
      status: 'Status',
      email: 'E-mail',
      date: 'Data wygaśnięcia',
      statusPending: 'Oczekujące',
      statusUsed: 'Użyte',
      statusAvailable: 'Dostępne',
      statusExpired: 'Wygasło',
      statusInvalidate: 'Unieważnione',
      promocodeComing: 'Wkrótce',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'Unieważniony',
      points_given: 'Twoje punkty zostały przyznane',
      referral_type_3: 'Bon podarunkowy',
      referral_type_2: 'Kod promocyjny',
      referral_type_1: 'Punkty'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'E-mail',
      emailError: 'Format e-maila jest nieprawidłowy',
      emailEmpty: 'Proszę wypełnić to pole',
      emailUnknown: 'Proszę utworzyć konto, aby móc polecać'
    }
  },
  SectionVipTiersProgress: {
    you: 'Ty',
    points: 'punkty'
  },
  SectionVipTiersCard: {
    rewardPoints: '{points} punktów przyznanych',
    rewardMultiplier: 'Mnożnik punktów: x{multiplier}',

    tiersPoints: '{amount} punktów'
  },
  SectionGifting: {
    empty: 'W tej chwili nie ma dostępnych testów produktów',
    showAll: 'Pokaż wszystko',
    ModalApply: {
      endDate: 'Data zakończenia aplikacji',
      description: 'Opis',
      completeForm: 'Wypełnij formularz, aby złożyć swoją aplikację',
      button: 'Złóż aplikację',
      success: {
        title: 'Rejestracja do testowania produktu',
        description:
          'Dziękujemy za wypełnienie informacji. Twoja aplikacja jest w trakcie przeglądu. Zostaniesz powiadomiony e-mailem.'
      },
      Form: {
        Errors: {
          required: 'Proszę wypełnić to pole',
          date: 'Proszę podać prawidłową datę'
        }
      }
    },
    ModalParticipate: {
      challenges: 'Misje',
      howItWorks: 'Jak to działa?',
      useCode: 'Użyj swojego kodu na naszej stronie podczas składania zamówienia.',
      youWillBeContacted: 'Skontaktujemy się z Tobą w celu odbioru produktu.',
      buttonLink: 'Link do produktu',
      buttonCopied: 'Skopiowane!'
    }
  },
  SectionGiftingCardList: {
    status: {
      participate: 'Weź udział',
      underValidation: 'W trakcie weryfikacji',
      apply: 'Złóż aplikację',
      ended: 'Zakończone',
      rejected: 'Aplikacja odrzucona'
    }
  },
  SectionSteps: {
    Authenticated: {
      month: '{n} miesiące| {n} miesięcy'
    },
    ModalActivities: {
      title: 'Moje ostatnie aktywności',
      empty: 'Nie masz jeszcze żadnych ostatnich aktywności.',
      table: {
        header: {
          title: 'Tytuł',
          points: 'Punkty',
          levelLabel: 'Niveau {level}',
          date: 'Data'
        }
      },
      events: {
        challenge: 'Misja zatwierdzona',
        order: 'Zamówienie złożone',
        reward: 'Nagroda zdobyta',
        refferal: 'Polecenie zatwierdzone',
        userAction: 'Punkty dostosowane',
        level: 'Osiągnięty poziom',
        levelLabel: 'Poziom {level}',
        reset: 'Wygaśnięcie punktów',
        expire: 'Wygaśnięcie punktów',
        automation: 'Punkty zdobyte'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'Połącz z moim kontem TikTok',
      subtitle: 'Jak to działa',
      description:
        'Proszę wprowadzić swoje konto Tiktok i upewnić się, że jest publiczne. Następnie będziesz mógł realizować misje na TikTok.',
      button: 'Połącz moje konto'
    },
    ModalLinked: {
      title: 'Połącz z moim kontem TikTok',
      subtitle: 'Połączenie z kontem zakończone sukcesem',
      congratulations: 'Gratulacje',
      description: 'Możesz teraz realizować misje.',
      buttons: {
        edit: 'Edytuj moje konto',
        goback: 'Wróć do strony'
      }
    }
  },
  SectionReferralFriend: {
    placeholder: 'Adres e-mail',
    emailError: 'Proszę podać prawidłowy adres e-mail',
    emailEmpty: 'Proszę podać swój adres e-mail',
    disclaimer: 'Ta oferta dotyczy tylko nowych klientów',
    disclaimerVerification: 'Nie będziesz kontaktowany w celach komercyjnych.',
    referral_type_3: 'Bon zakupowy',
    referral_type_2: 'Kod promocyjny',
    referral_type_1: 'Punkty',
    copied: 'Skopiowano!',
    label_optin_reminder: 'Chcę otrzymać przypomnienie, jeśli nie wykorzystam mojego rabatu.',
    btn_optin_reminder: 'Otrzymaj przypomnienie o moim kodzie'
  },
  Unsubscribe: {
    title: 'Czy naprawdę chcesz zrezygnować z otrzymywania e-maili z naszego programu lojalnościowego?',
    description:
      'Jeśli tak, pamiętaj, że nie będziesz już otrzymywać informacji o swoich nagrodach, misjach i punktach.',
    email: 'E-mail',
    button: 'Zaktualizuj moje preferencje',
    question: 'Jakiego rodzaju e-maile chcesz otrzymywać?',
    optinTransactional: 'Promocyjne: informacje o programie, poziomach VIP, nagrodach.',
    optinMarketing: 'Informacyjny: Informacje o zakupach i sponsoringu.',
    successTitle: 'Twoje preferencje zostały zaktualizowane',
    successDescription: 'Użyj poniższego przycisku, aby przejrzeć lub zmienić swoje preferencje',
    successButton: 'Zaktualizuj moje preferencje',
    errorTitle: 'Wystąpił błąd z linkiem przekierowania',
    errorButton: 'Przekieruj na stronę internetową'
  },
  SectionAccount: {
    copied: 'Skopiowano!'
  },
  SectionPointCard: {
    you: 'Ty',
    copied: 'Skopiowano!'
  }
}
